import { cx } from "@emotion/css";
import styled from "@emotion/styled";
import CloseIcon from "@mui/icons-material/Close";
import { isNil } from "lodash";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import Image from "src/components/Default/Image";

import { useFontSize } from "../../../hooks/useFontSize";
import { IconButton } from "../../Default/LekUI/Button";

export const ImageBox = styled("div")`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-left: 8px;
  max-width: 80px;
  position: relative;

  &:first-of-type {
    margin: 0;
  }

  > img {
    width: 60px;
    height: 60px;
    border: 1px solid rgb(0, 0, 0, 0.2);
    border-radius: 10px;
  }

  > span {
    color: rgb(123, 142, 157);
    font-size: 12px;
    margin-top: 4px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    text-align: center;
  }
`;

const MoreImages = styled(ImageBox)`
  position: relative;

  > div {
    cursor: pointer;
    position: absolute;
    top: 0;
    left: 0;
    width: 60px;
    height: 60px;
    background: rgb(0, 0, 0, 0.15);
    color: #fff;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 24px;
  }
`;

function Gallery({ images, maxImages, onDelete }) {
	const { getFontSizeClass } = useFontSize();
	const { t } = useTranslation();
	const [imageIndex, setImageIndex] = useState(null);

	const renderMoreImages = () => {
		if (isNil(maxImages) || maxImages >= images.length) {
			return;
		}

		const { image } = images[maxImages];

		return (
			<MoreImages>
				<img key={image} src={image} />
				<div onClick={() => setImageIndex(maxImages)}>
					+{`${images.length - maxImages}`}
				</div>
				<span>{t("commands.more")}</span>
			</MoreImages>
		);
	};

	const renderImages = () => {
		const img = images.slice(0, maxImages || images.length);

		return img.map(({ image, title }, index) => (
			<div key={image ?? index} className="gallery-image--container">
				<img
					className="gallery-image"
					key={image}
					src={image}
					onClick={() => setImageIndex(index)}
				/>
				{onDelete && (
					<IconButton
						className="gallery-image--delete-icon"
						onClick={() => onDelete(image)}
					>
						<CloseIcon />
					</IconButton>
				)}
				{title && (
					<span className={cx(getFontSizeClass(-2), "text-ellipsis-2")}>
						{title}
					</span>
				)}
			</div>
		));
	};

	return (
		<div className="flex">
			{imageIndex !== null && (
				<Image
					images={images}
					index={imageIndex}
					close={() => setImageIndex(null)}
				/>
			)}
			<div className="flex gap-8">
				{images && renderImages()}
				{images && renderMoreImages()}
			</div>
		</div>
	);
}

export default Gallery;
